<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="success || error" appMargin marginY="10px">
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
    </div>
    <!--Laboratory form  -->
    <div class="ui form" [formGroup]="detailForm">
      <div class="field required" [ngClass]="displayFieldCss('year')">
        <label> Year</label>
        <input suiDatepicker [pickerMode]="mode" [pickerMaxDate]="max" placeholder="year Of AOL" type="text"
          formControlName="year" />
        <app-field-error-display [displayError]="isFieldValid('year')" errorMsg="Please enter year">
        </app-field-error-display>
      </div>
    </div>
  </div>
</div>

<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Close
  </button>
  <button class="ui primary button" [ngClass]="{ yellow: pending }" [disabled]="!detailForm.valid || pending"
    (click)="submit()" autofocus>
    Done
  </button>
</div>
